/*
  The Elementor global header template renders as `position: fixed` — on
  iOS Safari a fixed element can render on top of a native/iframe fullscreen
  video presentation instead of being covered by it (a known WebKit
  compositing bug, not something scoped to any one video widget on the
  site). CSS alone (`body:has(:fullscreen) …`) covers browsers with `:has()`
  support; this fills in the same behavior via a body class for browsers
  that don't.
*/

export function initFullscreenHeaderFix() {
    var events = ['fullscreenchange', 'webkitfullscreenchange'];

    function isFullscreen() {
        return !!(document.fullscreenElement || document.webkitFullscreenElement);
    }

    function sync() {
        document.body.classList.toggle('is-fullscreen-active', isFullscreen());
    }

    events.forEach(function (eventName) {
        document.addEventListener(eventName, sync);
    });
}
